<template>
  <div class="bg-img min-height width-100 flex-column justify-content-center align-items-center">
    <!-- <div @click="getLoginUserDetail">重新登录</div> -->
    <van-icon name="https://b.yzcdn.cn/vant/icon-demo-1126.png" size="10rem" id="icon-image" color="grey" />
    <div class="width-30 textAlign-c margin-t fs-mid border br-reg" v-if="showLoginAgain" style="height: 3rem; line-height: 3rem" @click="userLogin">
      重新登录
    </div>
    <p class="tips mimic slideUp">有奖互动出品</p>
  </div>
</template>
<script>
import { getLoginUserDetail } from '@/api/login';
import { shopLogin } from '@/api/shop';
import { getDeviceInfo } from '@/utils/TmyUtils';
import { Toast } from 'vant';

export default {
  name: 'index',
  data() {
    return {
      show: false,
      accountId: null,
      sessionId: null,
      showLoginAgain: false
    };
  },
  async mounted() {
    console.log(localStorage.getItem('jryj_token'), '123');
    localStorage.clear();
    this.userLogin();
  },
  methods: {
    async userLogin() {
      let that = this;
      // if (process.env.NODE_ENV === 'development') {
      //   // 61d94200010ef63b9deffd19
      //   // 64b8b1fea95d5a0d21ffa25a
      //   // shopLogin({ account_id: '64b8b1fea95d5a0d21ffa25a', session_id: '6556c266f34e164c17f53a9f' }).then((res) => {
      //   getLoginUserDetail({ account_id: '64d04c8b3cbc2813523ce2f61', session_id: '122' }).then((res) => {
      //     if (res.code == 0) {
      //       localStorage.setItem('jryj_token', res.data.token);
      //       // localStorage.setItem('isShop', 'true');
      //       // localStorage.setItem('jryjShop_token', res.data.token);
      //       this.$store.commit('setUserInfo', { ...res.data });
      //       console.log(this.$route.query.path, 'dele');
      //       this.$router.replace(this.$route.query.path ? this.$route.query.path : '/home');
      //     }
      //   });
      // } else {
      console.log('mounted');
      /* eslint-disable no-undef,no-unused-vars */
      CP.getClientInfo({
        completed: function (data) {
          // data > {client_code:'zjxw',version: '5.0.0',detail:''}
          if (data.client_code == 'wx' || data.client_code == 'pc' || data.client_code == 'phone_web' || data.client_code == 'qq') {
            location.href = 'https://vapp.tmuyun.com/client/download.html?tenant_id=61';
          }
        },
        cpIncompatible: function () {
          CP.tools.writelog('', '此环境不支持此方法');
          location.href = 'https://vapp.tmuyun.com/client/download.html?tenant_id=61';
        }
      });
      this.accountId = await this.getAccountId();
      if (this.accountId == -1) {
        console.log('no_login');
        CP.showLogin({
          completed: function (data) {
            // 跳起登录弹窗
            that.accountId = data.account_id;
            that.sessionId = data.unique_id;
            that.getLoginUserDetail();
          },
          cpIncompatible: function () {
            // 跳入下载页面
            CP.tools.writelog('', '此环境不支持此方法');
            location.href = 'https://vapp.tmuyun.com/client/download.html?tenant_id=61';
          }
        });
      } else {
        console.log('hasLogin');
        this.sessionId = await this.getSessionId();
        this.getLoginUserDetail();
      }
      // }
      // }
    },
    getAccountId() {
      return new Promise((resolve, reject) => {
        // eslint-disable-next-line no-undef
        CP.getAccountId({
          completed: (data) => {
            resolve(data.account_id);
          },
          cpIncompatible: () => {
            reject('此环境不支持此方法');
          }
        });
      });
    },
    getSessionId() {
      return new Promise((resolve, reject) => {
        // eslint-disable-next-line no-undef
        CP.getUniqueId({
          completed: (data) => {
            console.log(data);
            resolve(data.unique_id);
          },
          cpIncompatible: () => {
            reject('此环境不支持此方法');
          }
        });
      });
    },
    async getLoginUserDetail() {
      let queryParams = {};
      let devInfo = await getDeviceInfo();
      console.log(devInfo, 'devInfo');
      queryParams.account_id = this.accountId;
      queryParams.session_id = this.sessionId;
      queryParams.device_no = devInfo.device_no;
      this.$store.commit('setQueryParams', queryParams);
      if (
        this.$route.query.path &&
        (this.$route.query.path == 'shop_home' || this.$route.query.path == 'shop_list' || this.$route.query.path == 'shop_tj')
      ) {
        shopLogin(queryParams)
          .then((res) => {
            let toast = Toast.loading({
              duration: 0,
              message: '登录中...',
              forbidClick: true,
              loadingType: 'spinner'
            });
            toast.clear();
            if (res.code == 0) {
              localStorage.setItem('isShop', 'true');
              localStorage.setItem('jryjShop_token', res.data.token);
              this.$store.commit('setShopUserInfo', res.data);
              let obj = {};
              for (let key in this.$route.query) {
                if (key != 'path') {
                  obj[key] = this.$route.query[key];
                }
              }
              this.$router.replace({ path: '/' + this.$route.query.path, query: obj });
            } else {
              Toast.fail('登录失败,您不是商家！');
              this.showLoginAgain = true;
            }
          })
          .catch((err) => {
            Toast('err.msg');
          });
      } else {
        getLoginUserDetail(queryParams).then((res) => {
          let toast = Toast.loading({
            duration: 0,
            message: '登录中...',
            forbidClick: true,
            loadingType: 'spinner'
          });
          console.log(res);
          toast.clear();
          if (res.code == 0) {
            localStorage.setItem('jryj_token', res.data.token);
            this.$store.commit('setUserInfo', res.data);
            if (this.$route.query.path) {
              let obj = {};
              console.log(this.$route.query);
              for (let key in this.$route.query) {
                if (key != 'path') {
                  obj[key] = this.$route.query[key];
                }
              }
              this.$router.replace({ path: '/' + this.$route.query.path, query: obj });
            } else {
              this.$router.replace('/home');
            }
          } else {
            Toast.fail(res.msg);
            this.showLoginAgain = true;
          }
        });
      }
    }
  }
};
</script>

<style lang="less" scoped>
.tips {
  position: fixed;
  bottom: 20px;
  font-size: 0.8rem;
  color: white;
}

.pic1 {
  margin-bottom: 80px;
}

.pic2 {
  position: relative;
  top: -30px;
  left: 70px;
}

.pic3 {
  position: relative;
  top: -80px;
}
::v-deep #icon-image .van-icon__image {
  width: 10rem;
  height: 10rem;
}
</style>
